import React, { useRef, useEffect, useState } from 'react';
import get from 'lodash/get';
import Button from '../../atoms/Button';
// import Grid from '../Grid';
import MarkerRed from '../../../../assets/images/marker-red.png';
import MarkerBlack from '../../../../assets/images/marker-black.png';
// import { baiduTheme } from './mapTheme';
import { useScriptCached } from '../../../utils/hooks';
import { BAIDU_DIRECTION_URL, BAIDU_MAP_API_URL } from '../../../../constants';
import { canUseDOM } from '../../../utils/canUseDOM';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { pushAnaylyticsData, createDynamicLabels } from '../../../../utils/analytics';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { modifyApi } from '../../../../utils/urls';

const BaiduMapComponent = ({
  markers,
  isRouteDirection,
  //isPolyline,
  highlightFirstMarker = true,
  labels,
  apiKey,
  componentName,
  pageName,
}) => {
  const mapCanvas = useRef(null);
  const mapZoomLevel = markers && markers.length > 1 ? 13 : 17;
  const [activeMarker, setActiveMarker] = useState();
  const [openAlert, setOpenAlert] = useState(false);

  // API should be coming from sitecore
  const [loaded] = useScriptCached(modifyApi(BAIDU_MAP_API_URL, { apiKey }));

  let bMap;
  let map;

  useEffect(() => {
    if (loaded && markers.length > 0) {
      const si = setInterval(() => {
        if (window.BMap) {
          bMap = window.BMap;
          initMap();
          clearInterval(si);
        }
      }, 1000);
    }
  }, [loaded, markers]);

  const getIcon = isActive => {
    return new bMap.Icon(
      isActive ? MarkerRed : MarkerBlack,
      new bMap.Size(40, 60),
      {
        anchor: new bMap.Size(20, 30),
        infoWindowAnchor: new bMap.Size(10, 0),
      }
    );
  };

  // Get user's consent to use geo location
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(onGeoSuccess);
    } else {
      console.warn('Geolocation not supported');
    }
  };

  // redirect to Baidu Map page with direction
  const openMapDirection = (lat, lng) => {
    const url = `${BAIDU_DIRECTION_URL}?origin=latlng:${lat},${lng}|name:Current Location&destination=latlng:${activeMarker.info.lat},${activeMarker.info.lng}|name:${activeMarker.info.name}&mode=driving&region=none&output=html`;

    const a = document.createElement('a');
    a.target = '_blank';
    a.href = url;
    a.click();
  };

  // if user grants permission to use geo cordinates
  const onGeoSuccess = position => {
    openMapDirection(position.coords.latitude, position.coords.longitude);
  };

  // gets geo coordinates if previously agreed
  // if not we will show alert window
  const getCoords = () => {
    return new Promise((resolve, reject) =>
      navigator.permissions
        ? // Permission API is implemented
        navigator.permissions
          .query({
            name: 'geolocation',
          })
          .then(permission =>
            // is geolocation granted?
            permission.state === 'granted'
              ? navigator.geolocation.getCurrentPosition(pos =>
                resolve(pos.coords)
              )
              : resolve(null)
          )
        : // Permission API was not implemented
        reject(new Error('Permission API is not supported'))
    );
  };

  // Attaches click event on direction button which is attached
  // to the window object.
  useEffect(() => {
    if (canUseDOM) {
      window.onGetDirectionClick = e => {
        e.preventDefault();

        getCoords().then(coords => {
          if (coords !== null) {
            // we have geo cordinates.
            openMapDirection(coords.latitude, coords.longitude);
          } else {
            // show alert window
            setOpenAlert(true);
          }
        });
      };
    }
  }, []);

  const getToolTipContent = marker => {
    return `<div class="makeStyles-infoWindow-532 baidu-infoWindow">
    <h4 class="MuiTypography-root MuiTypography-h6">${marker.name}</h4>
    <p class="MuiTypography-root MuiTypography-body2 makeStyles-address-533">${
      marker.address
      }</p>
    
    </div>`;

    // Commenting after </p> tag contents, Changes for vad 1.1 
    // <a onclick='onGetDirectionClick(event)' href="#" class="" target="_blank" rel="noopener noreferrer" aria-label="${get(
    //   labels,
    //   'GetDirections.value',
    //   'Get Directions'
    // )}">
    //   <span class="MuiButtonBase-root MuiButton-root MuiButton-text" tabindex="0" role="button" aria-disabled="false" aria-label="Get direction">
    //     <span class="MuiButton-label">
    //       <span class="MuiButton-startIcon MuiButton-iconSizeMedium">
    //         <span class="material-icons MuiIcon-root" aria-hidden="true">
    //           <svg class="MuiSvgIcon-root makeStyles-root-424" focusable="false" viewBox="0 0 24 24" aria-hidden="true" name="ArrowForwardSharpIcon">
    //             <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"></path>
    //           </svg>
    //         </span>
    //       </span> 
    //       ${get(labels, 'GetDirections.value', 'Get Directions')}
    //     </span>
    //   </span>
    // </a>
  };

  const addAnalyticsInfo = title => {
    const obj = {
      ...analyticsData.pageBodyInteraction.mapClick,
      ...{ label: createDynamicLabels(pageName, componentName, title) },
    };
    pushAnaylyticsData(obj)
  }

  const initMap = () => {
    if (mapCanvas.current) {
      map = new bMap.Map(mapCanvas.current);
      map.centerAndZoom(new bMap.Point(116.404, 39.915), 15);
      map.centerAndZoom(new bMap.Point(markers[0].lng, markers[0].lat), mapZoomLevel);

      map.addControl(new bMap.NavigationControl());
      map.addControl(new bMap.ScaleControl());

      // use custom style baiduTheme if required by updating the mapTheme.js file
      map.setMapStyle({ style: 'googlelite' });
      // map.setMapStyleV2({ styleJson: baiduTheme });

      const points = [];
      const addMarker = (item, index) => {
        const { lat, lng, title } = item;
        const infoContent = getToolTipContent(item);
        const { Marker, Point, InfoWindow } = bMap;
        const info = new InfoWindow(infoContent);
        const point = new Point(lng, lat);
        points.push(point);

        const marker = new Marker(point, {
          icon: getIcon(),
          title: title,
        });

        marker.addEventListener('click', function () {
          addAnalyticsInfo(title);
          this.openInfoWindow(info);
          this.setIcon(getIcon(true));
          setActiveMarker({ instance: this, info: item });
        });

        info.addEventListener('close', function () {
          marker.setIcon(getIcon());
          setActiveMarker(null);
        });

        map.addOverlay(marker);

        if (highlightFirstMarker && index === 0 && markers.length === 1) {
          marker.openInfoWindow(info);
          marker.setIcon(getIcon(true));
          setActiveMarker({ instance: marker, info: item });
        }
      };

      markers && markers.map((item, i) => addMarker(item, i));

      // used for fit bounds in baidu
      map.setViewport(points, { zoomFactor: -1 });

      if (isRouteDirection) {
        // enabled polyline as a fallback for driving route
        // disable this if driving route works
        // const polyline = new bMap.Polyline(points, { strokeColor: '#f00' });
        // map.addOverlay(polyline);

        // Enable this to show driving route
        // This is disabled as driving route is not enabled outside
        // China for the current account, check the below link for more info
        // http://lbsyun.baidu.com/index.php?title=webapi/direction-api-abroad

        const start = new bMap.Point(markers[0].lat, markers[0].lng);
        const end = new bMap.Point(
          markers[markers.length - 1].lat,
          markers[markers.length - 1].lng
        );

        const driving = new bMap.DrivingRoute(map, {
          renderOptions: {
            map: map,
            autoViewport: true,
            selectFirstResult: true,
          },
        });
        if (markers.length > 2) {
          const wp = markers
            .map(markr => new bMap.Point(markr.lat, markr.lng))
            .slice(1, -1);
          driving.search(start, end, { waypoints: [...wp] }); //waypoints
        } else {
          driving.search(start, end);
        }
      }
    }
  };

  // TODO: to remove this piece of code if Nearby Places not required
  // const getNearbyPlaces = () => {
  //   var local = new bMap.LocalSearch(map, {
  //     renderOptions: {
  //       map: map,
  //       autoViewport: false,
  //     },
  //   });
  //   //local.searchNearby('餐馆', new bMap.Point(markers[0].lng, markers[0].lat), 1000);
  //   local.searchNearby(
  //     'restaurant',
  //     new bMap.Point(markers[0].lng, markers[0].lat),
  //     1000
  //   );
  //   //local.setSearchCompleteCallback((result) => { console.log('searched result', result); })
  //   local.setMarkersSetCallback(result => {
  //     console.log('searched result2', result);
  //   });
  //   //console.log('searched result get ', local.getResults());
  // };

  // to handle close event of the dialong window
  const handleClose = agreed => {
    setOpenAlert(false);
    if (agreed) {
      getLocation();
    }
  };

  return (
    <div style={{ height: '100%' }}>
      <div id="map_canvas" ref={mapCanvas} style={{ height: '100%' }}></div>

      <Dialog
        open={openAlert}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {get(labels, 'geoDialogTitle.value', '')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {get(labels, 'geoDialogDescription.value', '')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleClose(false)}
            color="primary"
            buttonType="primary"
            size={'small'}
            hasBorder={false}
          >
            {get(labels, 'disagree.value', 'Disagree')}
          </Button>
          <Button
            onClick={() => handleClose(true)}
            color="primary"
            variant={'text'}
            autoFocus
            size={'small'}
            hasBorder={false}
          >
            {get(labels, 'agree.value', 'Agree')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* {markers && markers.length === 1 && (
        <div
          style={{
            position: 'absolute',
            bottom: '10px',
            left: '10px',
            zIndex: '9999',
          }}
        >
          <Grid container spacing={3}>
            <Grid item>
              <Button
                component="span"
                buttonType="form"
                field={{
                  value: {
                    text: 'Get Direction',
                    //href: `http://api.map.baidu.com/marker?location=39.916979519873,116.41004950566&output=html`,
                    href: `http://api.map.baidu.com/marker?location=${markers &&
                      markers[0].lat},${markers && markers[0].lng}&output=html`,
                    target: '_black',
                  },
                }}
                hasBorder={false}
              />
            </Grid>
            <Grid item>
              <div onClick={getNearbyPlaces}>
                <Button
                  component="span"
                  buttonType="form"
                  field={{
                    value: {
                      text: 'Get Nearby Places',
                    },
                  }}
                  hasBorder={false}
                />
              </div>
            </Grid>
          </Grid> 
        </div>
      )} */}
    </div>
  );
};

export default BaiduMapComponent;
